import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
// eslint-disable-next-line import-x/no-extraneous-dependencies
import * as ReactGA from 'react-ga';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { AccountProperties } from './account-manager/account-properties';
import { EditUserForm } from './users/edit-user-form';
import { Jobs } from 'components/account/jobs';
import { JobPage } from 'components/account/jobs-v2/JobPage';
import { JobPageRedirect } from 'components/account/jobs-v2/JobPageRedirect';
import { AmlMonitoringPage } from 'components/account/jobs-v2/dropdowns/AML/AmlMonitoringPage';
import { Loader } from 'components/account/loader';
import { SidebarV2 } from 'components/account/sidebar-v2/sidebar-v2';
import { UserVerification } from 'components/account/user-verification';
import { AccountGroupConfig } from 'components/admin/account-group-config/account-group-config';
import { AccountForm } from 'components/admin/account-manager/account-form';
import { AccountManager } from 'components/admin/account-manager/account-manager';
import { TemplateForm } from 'components/admin/templates/template-form';
import { TemplateManager } from 'components/admin/templates/template-manager';
import { AdminUsageReports } from 'components/admin/usage-reports/usage-reports';
import { UserManager } from 'components/admin/users/user-manager';
import { isProduction } from 'config';
import { ADMIN_PERMISSIONS, isAuthorized, SUPPORT_ADMIN_PERMISSIONS } from 'security/authorization';
import { useGlobalState } from 'store/reducers/reducer';
import { getUserInfo } from 'store/sagas/sagas';
export const Admin = () => {
    const { state, asyncDispatch } = useGlobalState();
    const navigate = useNavigate();
    const { pathname, search } = useLocation();
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        if (isProduction) {
            ReactGA.initialize('UA-151415696-1');
            ReactGA.pageview(pathname + search);
        }
    });
    useEffect(() => {
        if (!state.accessToken)
            navigate('/signin');
    });
    useEffect(() => {
        if (!state.user) {
            loadUserInfo();
        }
        else if (isLoading) {
            /*
             * already in from sign in / forget / sign up
             * clear loading
             */
            setIsLoading(false);
        }
    }, [state.user]);
    const loadUserInfo = () => {
        asyncDispatch(getUserInfo())
            .catch(console.error)
            .finally(() => {
            setIsLoading(false);
        });
    };
    const isAdmin = state.user
        ? isAuthorized(state.user, ADMIN_PERMISSIONS)
        : false;
    const isSupportAdmin = state.user
        ? isAuthorized(state.user, SUPPORT_ADMIN_PERMISSIONS)
        : false;
    const [noScroll, setNoScroll] = useState(false);
    return isLoading ? (React.createElement(Loader, null)) : (React.createElement("div", { className: classNames('account u-flex-row', { noscroll: noScroll }) },
        React.createElement(SidebarV2, { toggleScroll: setNoScroll }),
        React.createElement("div", { className: "u-padding-medium u-flex-1 u-flex-column u-align-vertical-center content" },
            React.createElement(UserVerification, { user: state.user }),
            React.createElement(Routes, null,
                (isAdmin || isSupportAdmin) && (React.createElement(React.Fragment, null,
                    React.createElement(Route, { element: React.createElement(Jobs, { basePath: "/admin/jobs", isAdmin: true }), path: "jobs" }),
                    React.createElement(Route, { element: React.createElement(JobPageRedirect, { isAdmin: true }), path: "job/:id" }),
                    React.createElement(Route, { element: React.createElement(JobPage, null), path: "jobs/:id" }),
                    React.createElement(Route, { element: React.createElement(AmlMonitoringPage, null), path: "jobs/:id/monitoring" }),
                    React.createElement(Route, { element: React.createElement(AccountManager, null), path: "accounts" }),
                    React.createElement(Route, { element: React.createElement(AccountForm, null), path: "accounts/:id" }),
                    React.createElement(Route, { element: React.createElement(AccountProperties, null), path: "accounts/:id/properties" }),
                    React.createElement(Route, { element: React.createElement(UserManager, null), path: "users" }),
                    React.createElement(Route, { element: React.createElement(EditUserForm, null), path: "users/:id" }),
                    React.createElement(Route, { element: React.createElement(AdminUsageReports, null), path: "usage-reports" }),
                    React.createElement(Route, { element: React.createElement(AccountGroupConfig, null), path: "accounts/:id/groupconfig" }))),
                isAdmin && (React.createElement(React.Fragment, null,
                    React.createElement(Route, { element: React.createElement(TemplateManager, null), path: "templates" }),
                    React.createElement(Route, { element: React.createElement(TemplateForm, null), path: "templates/:id" }))),
                React.createElement(Route, { element: React.createElement(Navigate, { replace: true, to: "/admin/jobs" }), path: "*" })))));
};
